
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Landing from "../pages/landing/page";
import Home from "../pages/home/page";
import Packages from "../pages/packages/page";
import Staging from "../pages/staging/page";
import Portfolio from "../pages/portfolio/page";
import PortfolioCommercial from "../pages/portfolio-commercial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/packages",
    element: <Packages />,
  },
  {
    path: "/staging",
    element: <Staging />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/portfolio/commercial",
    element: <PortfolioCommercial />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
